import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { FONTS, SECONDARY_COLOR } from "../../constants";
import { stateTypeF } from "../../state";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxTitle: {
      fontFamily: FONTS,
      fontSize: "20px",
      margin: "20px",
      color: "rgba(0,0,0,0.7)",
      fontWeight: "bold",
    },
    buttonsContainer: {
      display: "flex",
      color: "rgba(0,0,0,0.5)",
      flexDirection: "row",
      marginTop: "20px",
      marginBottom: "20px",
      marginLeft: "auto",
      marginRight: "30px",
    },
    dropdownTitle: {
      fontFamily: FONTS,
      marginLeft: "0px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      width: "120px",
    },
    avatarsSelectContainer: { marginLeft: "0px", marginBottom: "30px" },
    avatarsRow: {},
    avatarIcon: {
      width: "70px",
      border: "solid",
      borderWidth: "0px",
      borderRadius: "10px",
      marginLeft: "20px",
      marginTop: "20px",
      cursor: "pointer",
    },
  })
);

type boxTitleType = { title: string };
function BoxTitle({ title }: boxTitleType) {
  function Line() {
    return (
      <div
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: "rgba(0,0,0,0.2)",
          position: "relative",
          marginTop: "-10px",
        }}
      ></div>
    );
  }
  const classes = useStyles();
  return (
    <div style={{ width: "100%" }}>
      <div className={classes.boxTitle}>{title}</div>
      <Line></Line>
    </div>
  );
}

type areYouSurePopupType = {
  state: stateTypeF;
  title: string;
  message: string;
  handleContinue: () => void;
  handleCancel: () => void;
  isOpenTF: boolean;
  continueLabel: string;
};

export function AreYouSurePopup({
  state,
  title,
  message,
  handleContinue,
  handleCancel,
  isOpenTF,
  continueLabel,
}: areYouSurePopupType) {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpenTF}
      onClose={() => {
        state.setIsDeletePersonaOpen(false);
      }}
      maxWidth="lg"
    >
      <div
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <BoxTitle title={title}></BoxTitle>
        <div
          style={{
            fontFamily: FONTS,
            marginTop: "20px",
            color: "rgba(0,0,0,0.8)",
            fontSize: "18px",
            margin: "20px",
          }}
        >
          {message}
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCancel}
            style={{
              fontFamily: FONTS,
              visibility: handleCancel === undefined ? "hidden" : "visible",
              fontWeight: "bold",
              width: "110px",
              height: "40px",
              marginRight: "10px",
              backgroundColor: "rgba(0,0,0,0.3)",
            }}
          >
            {"Cancel"}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleContinue}
            style={{
              fontFamily: FONTS,
              fontWeight: "bold",
              width: "110px",
              height: "40px",
              backgroundColor: SECONDARY_COLOR,
            }}
          >
            {continueLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
